import { render, staticRenderFns } from "./StorePage.vue?vue&type=template&id=ec367a6c&scoped=true&"
import script from "./StorePage.vue?vue&type=script&lang=js&"
export * from "./StorePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec367a6c",
  null
  
)

export default component.exports